module.exports = __webpack_public_path__ + "static/media/social-500px.137a8ebf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-500px.svg
// module id = 99
// module chunks = 0